import {DocumentStub} from '../state/document/document-list.model';
import {Modal} from '../../../modules/modal/state/modal.model';

export const DOCUMENT_EDIT_MODAL_ID = 'document-edit-modal-id';

export interface DocumentEditModal extends Modal {
  document: DocumentStub
}
